import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { reset, setAllAuthorities, setLoading } from './actions';

const authoritiesReducer = handleActions(
  {
    [setAllAuthorities.toString()]: (_, { payload: authorities }) =>
      authorities,
    [reset.toString()]: () => []
  },
  []
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  authorities: authoritiesReducer,
  loading: loadingReducer
});
